import { SortArrows } from "@rio-cloud/rio-uikit";

export type TDirection = {
    column: string;
    asc: boolean;
};

type THeader = {
    name: string;
    label: string;
}

interface Props {
    directions: TDirection,
    header: THeader[];
    onClick: (direction: TDirection) => void;
}

const Header = ({ header, directions, onClick }: Props) => {
    return (
        <tr className="bg-white">
            <th
                key={"select"}
                data-field={"select"}
                className="width-60 bg-lightest"
            ></th>
            {header.map((h) => {
                return (
                    <th
                        className="user-select-none sort-column bg-lightest"
                        key={h.name}
                        data-field={h.name}
                        onClick={() => {
                            h.name !== directions.column
                                ? onClick({
                                    column: h.name,
                                    asc: true,
                                })
                                : onClick({
                                    column: h.name,
                                    asc: !directions.asc,
                                })
                        }}
                    >
                        <span>
                            {directions.column === h.name ? (
                                <SortArrows
                                    direction={
                                        !!directions.asc ? "asc" : "desc"
                                    }
                                    key={h.name}
                                />
                            ) : (
                                <SortArrows key={h.name} />
                            )}
                            <span className="text-capitalize">
                                {h.label}
                            </span>
                        </span>
                    </th>
                );
            })}
        </tr>
    )
};

export default Header;